import { DEVICE_FEATURE_VERSIONS } from "./feature.constant";
import type { DeviceFeature, DeviceType } from "./feature.type";
import { isVersionAtLeast } from "./version.helper";

export const getFeatureRequiredVersion = <T extends DeviceType>(deviceType: T, feature: DeviceFeature<T>): string =>
  (DEVICE_FEATURE_VERSIONS[deviceType] as Record<DeviceFeature<T>, string>)[feature];

export function isFeatureSupported<T extends DeviceType>(
  deviceType: T,
  feature: DeviceFeature<T>,
  version: string | undefined,
): boolean {
  return isVersionAtLeast(version, getFeatureRequiredVersion(deviceType, feature));
}
